module.exports = __webpack_public_path__ + "img/25.bba7f5d0.jpg";